import { Menu } from "./Menu";

import { CustomAppBar } from "components/CustomAppBar";
import { CustomSideBar } from "components/CustomSideBar";

import { PullDownToRefreshLayout } from "components/PullDownToRefreshLayout";

const withPaddingUrls = [
  "/dashboard/Appointment-service-reporting",
  "/dashboard/Tipping-reporting",
  "/dashboard/Transactions-reporting",
  "/dashboard/Cancelled-appointment-reporting"
];

export const Layout = (props: any) => {
  const isWithPadding = withPaddingUrls.find(
    (item) => item === window.location.pathname
  );
  return (
    <PullDownToRefreshLayout
      sx={{
        minHeight: "100dvh",
        // layout & appBar & sidebar & menu
        "& .RaLayout-appFrame": { marginTop: 0 },
        "& .RaLayout-contentWithSidebar": {
          backgroundColor: "#FAF9F7",
          display: "flex !important"
        },
        "& .RaLayout-content": {
          backgroundColor: "#F6F4F1",
          paddingLeft: "16px",
          paddingRight:
            window.location.pathname === "/dashboard/Services-calendar" ||
            window.location.pathname === "/dashboard" ||
            window.location.pathname === "/dashboard/"
              ? "0px"
              : "16px",
          "@media screen and (max-width:430px)": {
            paddingLeft: isWithPadding ? "16px" : "0px",
            paddingRight: isWithPadding ? "16px" : "0px"
          }
        },

        // show/edit/create main container (paper)
        "& .MuiCard-root": {
          backgroundColor: "rgba(250, 249, 247, 1)",
          boxShadow: "none"
        },

        // input & input siblings like error textField etc. (stats here)
        "& .MuiFilledInput-root": {
          borderRadius: "8px",
          border: "1px solid rgba(48, 47, 46, 0.06)"
        },
        "& .MuiFilledInput-input": {
          height: "24px",
          fontSize: "16px",
          borderRadius: "8px",
          fontFamily: "Inter",
          border: "none"
        },
        "& .MuiFilledInput-input:focus": {
          boxShadow: "none",
          borderRadius: "8px !important"
        },
        "& .MuiFilledInput-root:before": {
          border: "none !important"
        },
        "& .MuiFilledInput-root:after": {
          border: "1px solid #b8722a !important",
          top: "0px",
          borderRadius: "8px",
          transition: "none"
        },
        "& .MuiFilledInput-root.Mui-error:after": {
          border: "1px solid #EF5B1B !important"
        },
        "& .MuiFilledInput-root.Mui-disabled": {
          backgroundColor: "rgba(48, 47, 46, 0.06)"
        },
        "& .MuiTextField-root": {
          marginTop: "3px",
          marginBottom: "3px"
        },
        "& .MuiInputLabel-root": {
          fontSize: "16px",
          color: "rgba(48, 47, 46, 0.6)"
        },
        "& .MuiInputLabel-root.Mui-focused": {
          color: "#b8722a"
        },
        "& .MuiFormHelperText-root": {
          fontSize: "12px",
          marginTop: "2px",
          marginBottom: "2px",
          lineHeight: "14px"
        },
        // input (ends here)

        // custom toolbar (save & delete)
        ".RaToolbar-desktopToolbar": {
          backgroundColor: "rgba(250, 249, 247, 1)",
          minHeight: "44px",
          marginBottom: "24px"
        },
        "& .RaToolbar-defaultToolbar .MuiButton-containedPrimary": {
          borderRadius: "32px",
          backgroundColor: "rgba(34, 46, 66, 1)",
          fontSize: "14px",
          textTransform: "capitalize",
          boxShadow: "none",
          "&:hover": {
            backgroundColor: "rgba(22, 30, 44, 1)"
          }
        },
        "& .RaToolbar-defaultToolbar .MuiButtonBase-root.Mui-disabled": {
          backgroundColor: "rgba(48, 47, 46, 0.12)"
        },
        "& .RaToolbar-defaultToolbar .ra-delete-button": {
          textTransform: "capitalize"
        },

        // links in "show" view
        "& .RaReferenceField-link>*": {
          color: "#16667A !important"
        },
        "& .MuiLink-underlineAlways": {
          color: "#16667A",
          textDecoration: "none"
        },

        "& .MuiLink-underlineAlways:hover": {
          textDecoration: "underline"
        },

        // "show" label
        "& .RaSimpleShowLayout-row .RaLabeled-label": {
          fontSize: "14px"
        }
      }}
      {...props}
      className={"layout-main-element"}
      appBar={CustomAppBar}
      sidebar={CustomSideBar}
      menu={Menu}
    />
  );
};
